import React from "react";
import PlanetCard from "../PlanetCard/PlanetCard";
import DoneIcon from "@mui/icons-material/Done";
import "./ResetSuccess.scss";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
const ResetSuccess = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="flex">
      <PlanetCard />
      <div className="flex flex-col w-40v  pw-height-100v pw-align-center">
        <DoneIcon className="pw-circle flex" />

        <div className="pw-status-message flex font-bold pt-4 pb-12">
          {t("Password Reset Successfully")}
        </div>
        {/* <input type="submit" className='pw-primary-button' value="Sign Up" /> */}
        {/* <Button type='submit' variant="contained" className='pw-signin-button'> Proceed To SignIn </Button> */}
        <NavLink to="/auth/login" className="pw-signin-button">
          {t("Password Reset Successfully")}{" "}
        </NavLink>
      </div>
    </div>
  );
};

export default ResetSuccess;
